import SlimSelect from "slim-select"

export function setupColorModelSelect({
  colorSelect,
  modelSelect,
  onAnyChange,
}) {
  if (!colorSelect || !modelSelect) return null

  setOptionHtml(colorSelect)
  setOptionHtml(modelSelect)

  const allModelData = Array.from(modelSelect.querySelectorAll("option")).map(
    (opt) => ({
      text: opt.textContent,
      html: opt.dataset.html || "",
      value: opt.value,
      placeholder: !opt.value,
    }),
  )

  const modelSlim = new SlimSelect({
    select: modelSelect,
    settings: { showSearch: false, placeholderText: "" },
    events: {
      afterChange: () => onAnyChange?.(),
    },
  })

  const colorSlim = new SlimSelect({
    select: colorSelect,
    settings: { showSearch: false, placeholderText: "" },
    events: {
      afterChange: () => {
        filterModels(colorSelect, modelSelect, modelSlim, allModelData)
        onAnyChange?.()
      },
    },
  })

  if (colorSelect.value) {
    filterModels(colorSelect, modelSelect, modelSlim, allModelData)
  }

  return { colorSlim, modelSlim }
}

function filterModels(colorSelect, modelSelect, modelSlim, allModelData) {
  const selectedOption = colorSelect.options[colorSelect.selectedIndex]
  const modelIds = (selectedOption?.dataset.modelIds || "")
    .split(",")
    .filter(Boolean)
  const currentModel = modelSelect.value

  const withAvailability = allModelData.map((opt) => {
    const available =
      opt.placeholder || modelIds.length === 0 || modelIds.includes(opt.value)

    if (opt.html) {
      return { ...opt, html: opt.html, disabled: !available }
    }

    return { ...opt, disabled: !available }
  })

  modelSlim.setData(withAvailability)

  if (currentModel && modelIds.length > 0 && !modelIds.includes(currentModel)) {
    modelSlim.setSelected("")
  } else if (currentModel) {
    modelSlim.setSelected(currentModel)
  }
}

function setOptionHtml(select) {
  select.querySelectorAll("option[data-icon]").forEach((opt) => {
    if (!opt.dataset.icon) return
    opt.dataset.html =
      '<img src="' + opt.dataset.icon + '"><span>' + opt.textContent + "</span>"
  })
}
